export default "__VITE_ASSET___app/immutable/assets/modal-logo-terminal.DAwZ1-5T.svg__"